
import React from 'react';
import { Button } from '@/components/ui/button';
import { CheckCircle, Loader2 } from 'lucide-react';

interface OnboardingSuccessViewProps {
  setupComplete: boolean;
  onContinue: () => void;
  businessName: string;
  subdomain: string;
}

const OnboardingSuccessView: React.FC<OnboardingSuccessViewProps> = ({
  setupComplete,
  onContinue,
  businessName,
  subdomain
}) => {
  return (
    <div className="py-6 px-4 sm:p-8 text-center">
      {!setupComplete ? (
        <div className="flex flex-col items-center space-y-4">
          <div className="animate-pulse">
            <Loader2 className="h-16 w-16 text-primary animate-spin" />
          </div>
          <h3 className="text-xl font-semibold text-gray-900">Setting up your business...</h3>
          <p className="text-gray-600 max-w-md mx-auto">
            We're configuring your referral program. This will just take a moment.
          </p>
        </div>
      ) : (
        <div className="flex flex-col items-center space-y-6">
          <div className="bg-green-100 rounded-full p-3">
            <CheckCircle className="h-16 w-16 text-green-600" />
          </div>
          
          <div>
            <h3 className="text-2xl font-bold text-gray-900">Setup Complete!</h3>
            <p className="text-gray-600 max-w-md mx-auto mt-2">
              Your referral program has been successfully created.
            </p>
          </div>
          
          <div className="bg-blue-50 border border-blue-100 rounded-lg p-4 w-full max-w-md mx-auto">
            <h4 className="text-lg font-medium text-blue-900">Business Details</h4>
            <div className="mt-3 space-y-2">
              <div>
                <span className="text-blue-700 font-medium">Business Name:</span>
                <span className="ml-2 text-blue-800">{businessName}</span>
              </div>
              <div>
                <span className="text-blue-700 font-medium">Your Domain:</span>
                <span className="ml-2 text-blue-800">{subdomain}.referme.site</span>
              </div>
            </div>
          </div>
          
          <Button 
            onClick={onContinue}
            className="px-8 py-6 text-lg bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700"
            size="lg"
          >
            Continue to Dashboard
          </Button>
        </div>
      )}
    </div>
  );
};

export default OnboardingSuccessView;
